import { compose, setDisplayName } from 'recompose';

const enhance = compose(setDisplayName('CreditCardTile'));

export default enhance;
